<template>
    <div>
        <form @submit.prevent="saveTeam">
            <div class="form-group col-12">
                <label for="name">Team Name</label>
                <input type="text" id="name" v-model="team.name" class="form-control">
            </div>
            <team-members-component  :team_id="team.id" ref="members"></team-members-component>
        </form>

    </div>
</template>

<script>

import TeamMembersComponent from "../../teams/TeamMembersComponent.vue";
import _ from "lodash";

export default {
    name: "TeamForm",
    components: {TeamMembersComponent},
    data() {
        return {
            team: {
                id: null,
                name: "",
                members: []
            },
            formTitle: "Team Management",
            submitButtonText: "Save Entry As New",
        };
    },
    mounted() {
    },
    methods: {
        saveTeam() {

            this.team.members = this.$refs.members.items;
            let leader = this.$refs.members.leader;


            if (this.team.id) {
                axios
                    .put(`/teams/${this.team.id}/update`, {team: this.team, leader: leader})
                    .then(() => {
                        showMessage('s', "Team updated successfully!");
                        this.$emit('updated')
                    })
                    .catch((error) => {
                        console.error(error);
                        showMessage('e', "An error occurred while updating the team");
                    });
            } else {
                axios
                    .post("/teams/store", {team: this.team, leader: leader})
                    .then(() => {
                        showMessage('s', "Team created successfully!");
                        this.$emit('created')
                    })
                    .catch((error) => {
                        let message = '';
                        if (_.has(error, 'response.data.errors')) {

                            message = 'Please review the issue(s) below:';
                            this.errors = error.response.data.errors;
                            const [key, value] = Object.entries(this.errors)[0];
                            message = value[0]


                        } else if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'It was not possible to perform this operation! ' + error.response.status;

                        } else {

                            message = 'Error ' + error.message;
                            console.log(error);
                        }

                        showMessage('e', message);
                    });
            }
        },
        async getTeam(id) {
            let result = await axios.get(`/teams/${id}/retrieve`)
            this.team = result.data.data
            this.$refs.members.setMembers(this.team.members.map((e) => e.pivot));
        },
        newTeam() {
            this.team = {
                id: null,
                name: "",
                members: []
            }
            this.$refs.members.setMembers([])
        }
    },
};
</script>

<style scoped>
</style>
